import { Injectable } from '@angular/core';
import { DetailedTag } from 'src/services/tag/DetailedTag';

@Injectable({
  providedIn: 'root',
})
export class TagSelectionService {
  selectedTags: DetailedTag[] = [];

  constructor() {}
}
